<template>
  <div>
    <!-- Modal for category selection -->
    <b-modal
      id="category-modal"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="`${$t('common.select')} ${$t('warehouse.one-category')}`"
    >
      <b-card-text>
        <b-row>
          <!-- AutoComplete component for selecting categories -->
          <b-col md="12">
            <AutoComplete
              v-model="selectedCategory"
              :label="$t('warehouse.category')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-category'
              )}`"
              :serializer="(val) => val"
              endpoint="category"
              text-title="name"
              :otherQuery="`filter[type]=${
                isPharmacy ? 'pharmacy' : 'hospital'
              }`"
              @input="onCategorySelected"
            />
          </b-col>

          <!-- RecursiveCategoryAutoComplete component for subcategories -->
          <b-col md="12" v-if="shouldRenderSubcategory">
            <recursive-category-auto-complete
              :category="selectedCategory"
              :depth="1"
              @final-value="handleFinalValue"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Form group for displaying selected category -->
    <b-form-group :label="$t('warehouse.category')" label-for="Name">
      <b-form-input
        id="Name"
        v-model="selectedCategory.name"
        :placeholder="$t('warehouse.one-category')"
        @click="$bvModal.show('category-modal')"
      />
    </b-form-group>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BCardText,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const RecursiveCategoryAutoComplete = () =>
  import("@/components/common/RecursiveCategoryAutoComplete.vue");

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BFormGroup,
    BFormInput,
    AutoComplete,
    ToastificationContent,
    RecursiveCategoryAutoComplete,
  },

  props: {
    isPharmacy: Boolean,
    id: String,
  },

  data() {
    return {
      selectedCategory: {
        name: null,
        id: "",
      },
    };
  },

  computed: {
    shouldRenderSubcategory() {
      return (
        this.selectedCategory &&
        this.selectedCategory.childs &&
        this.selectedCategory.childs.length > 0
      );
    },
  },
  mounted() {
    if (this.id) {
      this.getById(this.id);
    }
  },
  methods: {
    onCategorySelected(value) {
      this.$emit("category", this.selectedCategory);
    },

    handleFinalValue(value) {
      this.selectedCategory = value;
      this.$emit("category", value);
    },
    async getById(id) {
      const url = `category/${id}`;

      await this.getList(url);
      this.selectedCategory = this.all_data;
      this.$emit("category", this.all_data);
    },
  },
};
</script>
